import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '@/features/layout/app-shell';
import { meQuery, useMe } from '@/lib/auth';

/** Everything behind sign-in. Unverified sessions are sent to finish two-step verification. */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    const next = location.pathname.replace(/^\/admin/, '') || '/';
    if (!me) throw redirect({ to: '/login', search: { redirect: next === '/' ? undefined : next } });
    if (!me.mfaVerified) throw redirect({ to: me.mfaEnrolled ? '/verify' : '/setup-2fa', search: { redirect: next } });
    return { me };
  },
  component: AppLayout,
});

function AppLayout() {
  const me = useMe();
  return (
    <AppShell me={me}>
      <Outlet />
    </AppShell>
  );
}
